document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.js-tabcontent').length === 0) {
    return  // 要素が存在しなければ、関数の実行を停止
  }

  const tabscontents = document.querySelectorAll('.js-tabcontent')
  const tabs = document.querySelectorAll('.js-tab')

  tabscontents[0].classList.add('active')
  tabs[0].classList.add('active')
  tabs.forEach((el, index) => {
    el.addEventListener('click', () => {
      tabs.forEach((tab) => { tab.classList.remove('active'); });
      tabscontents.forEach((content) => { content.classList.remove('active') })

      el.classList.add('active')
      tabscontents[index].classList.add('active')
    })
  })
})


